export const BOOKING_DATETIME_FORMAT = "yyyy-MM-dd'T'HHmm";

export const COMMONWEALTH_GROUP_NAME_PATTERN = 'Commonwealth';

export const COVID_DOSE_1_APPOINTMENT_TYPE = 'COVID-19 Vaccine (First Dose)';

export const COVID_DOSE_2_APPOINTMENT_TYPE = 'COVID-19 Vaccine (Second Dose)';

export const ESTABLISHMENT_TYPE_PHARMACY = 'Pharmacy';

export const NHSD_REFERRER_PATTERN = /covid-vaccine.healthdirect.gov.au/;

export const PRACTICE_ID_DENTAL_FTAU = '66381';

export const PRACTICE_ID_247MEDCARE = '82374';

export const PRACTICE_ID_DOD = '68480';

export const PRACTICE_ID_TEST_DOD = '82421';

export const PRESCRIPTION_APPOINTMENT_TYPE = 'Prescription';

export const SPECIALTY_CHIROPRACTIC = 'Chiropractic';

export const SPECIALTY_COUNSELLING = 'Counselling';

export const SPECIALTY_COVID_19_VACCINATIONS = 'COVID-19 Vaccinations';

export const SPECIALTY_COVID_19_AND_FLU_VACCINATIONS = 'COVID-19 and Flu Vaccinations';

export const SPECIALTY_DENTISTRY = 'Dentistry';

export const SPECIALTY_FLU_VACCINATIONS = 'Flu Vaccinations';

export const SPECIALTY_GENERAL_PRACTICE = 'General Practice';

export const ALL_PRACTITIONERS_ID = '0';

export const SPECIALTY_PHARMACY = 'Pharmacy';

export const SPECIALTY_PHYSIOTHERAPY = 'Physiotherapy';

export const SPECIALTY_PODIATRY = 'Podiatry';

export const SPECIALTY_PSYCHOLOGY = 'Psychology';

export const SPECIALTY_OPTOMETRY = 'Optometry';

export const SPECIALTY_SKIN_CANCER = 'Skin Cancer';

export const SPECIALTY_RADIOLOGY = 'Radiology';

export const APPT_TYPE_NAME_PHONE_CONSULT_PRIVATELY_BILLED = 'Phone Consult (Privately Billed)';
